<template>
  <div class="message-location">
    <span v-if="address">
      {{ address }}<br>
    </span>
    <a :href="yaMapLink" target="_blank">Открыть в Yandex Maps</a>
  </div>
</template>

<script>
export default {
  props: {
    address: {
      type: String,
      default: ''
    },

    longitude: {
      type: Number,
      required: true
    },

    latitude: {
      type: Number,
      required: true
    }
  },

  computed: {
    yaMapLink () {
      return `https://yandex.ru/maps?pt=${this.longitude},${this.latitude}&z=17&l=map`
    }
  }
}
</script>
